import React, {Fragment, useMemo} from 'react';
import {Listbox, Transition} from "@headlessui/react";
import {CheckIcon, ChevronUpDownIcon} from "@heroicons/react/24/solid";
import {classNames} from "../../../utils/common";

const TagsPicker = ({label, tags, setTags, tagsList, smallerSize = false, ...props}) => {
    const selectorTagsWidth = useMemo(() => {
        let maxWidth = 1;
        tagsList.forEach(tag => {
            let tagWidth = tag.name.length * 8;
            if (tagWidth > maxWidth) {
                maxWidth = tagWidth;
            }
        });
        return maxWidth + (smallerSize ? 30 : 50) + 'px';
    }, [tagsList, smallerSize]);

    const tagsString = useMemo(() => tags.map(tag => '[' + tag.name + ']').join(' '), [tags]);

    return (
        <Listbox as="div" value={tags} onChange={setTags} multiple {...props}>
            {({ open }) => (
                <>
                    {label && <Listbox.Label className={classNames(
                        smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                        "block font-medium text-gray-700"
                    )}>{label}</Listbox.Label>}
                    <div className={classNames(smallerSize ? "mt-0.5 h-7" : "mt-1 h-10", "relative")}>
                        <Listbox.Button className={classNames(
                            smallerSize
                                ? "h-7 pl-1.5 pr-1.5 py-1 text-xs"
                                : "pl-3 pr-3 py-2 sm:text-sm",
                            "relative bg-white border border-gray-300 rounded-md shadow-sm text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                        )}
                                        style={{minWidth: selectorTagsWidth}}>
                            <span className="flex items-center justify-between">
                                <span className={classNames(smallerSize ? "ml-1" : "ml-3", "block whitespace-nowrap truncate")}>{tagsString}</span>
                                <span className={classNames(smallerSize ? "ml-1" : "ml-3", "flex items-center pointer-events-none")}>
                                    <ChevronUpDownIcon className={classNames(smallerSize ? "h-4 w-4" : "h-5 w-5", "text-gray-400")} aria-hidden="true"/>
                                </span>
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options className={classNames(
                                smallerSize ? "text-xs" : "text-base sm:text-sm",
                                "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-96 rounded-md py-1 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none"
                            )}>
                                {tagsList.map((tagOption) => (
                                    <Listbox.Option
                                        key={tagOption.id}
                                        className={({ active }) =>
                                            classNames(active
                                                    ? 'bg-indigo-600 text-white'
                                                    : 'text-gray-900',
                                                smallerSize ? 'py-1 pl-2 pr-7' : 'py-2 pl-3 pr-9',
                                                'relative cursor-default select-none')
                                        }
                                        value={tagOption}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <div className="flex items-center">
                                                    <span className={classNames(
                                                        selected ? 'font-semibold' : 'font-normal',
                                                        smallerSize ? 'ml-1' : 'ml-3',
                                                        'block truncate'
                                                    )}>
                                                        {tagOption.name}
                                                    </span>
                                                </div>
                                                {selected && <span className={classNames(
                                                    active ? 'text-white' : 'text-indigo-600',
                                                    smallerSize ? 'pr-2' : 'pr-4',
                                                    'absolute inset-y-0 right-0 flex items-center'
                                                )}>
                                                    <CheckIcon className={classNames(smallerSize ? "h-4 w-4" : "h-5 w-5")} aria-hidden="true"/>
                                                </span>}
                                            </>
                                        )}
                                    </Listbox.Option>)
                                )}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>)}
        </Listbox>
    );
};

export default TagsPicker;
